import { gql } from 'graphql-request'

export const FETCH_CANDIDATE_PROFILE = gql`
  query candidateProfile($id: ID!) {
    candidateProfile(id: $id) {
      slug
      currentState
    }
  }
`
